import PropTypes from 'prop-types';

import { ConsolidacionNotificacion } from 'src/components/consolidacion-notificacion';
import { ChatLauncher } from 'src/layouts/dashboard/chat-button/chat-launcher';
import { useResponsiveTables } from 'src/components/responsive-tables';
import { withAuthGuard } from 'src/hocs/with-auth-guard';
import { useSettings } from 'src/hooks/use-settings';

import { useSections } from './config';
import { HorizontalLayout } from './horizontal-layout';
import { VerticalLayout } from './vertical-layout';

export const Layout = withAuthGuard(({ children, ...props }) => {
  const settings = useSettings();
  const sections = useSections();
  useResponsiveTables();

  if (settings.layout === 'horizontal') {
    return (
      <HorizontalLayout
        sections={sections}
        navColor={settings.navColor}
        {...props}
      >
        {children}
        <ConsolidacionNotificacion />
        <ChatLauncher />
      </HorizontalLayout>
    );
  }

  return (
    <VerticalLayout
      sections={sections}
      navColor={settings.navColor}
      {...props}
    >
      {children}
      <ConsolidacionNotificacion />
      <ChatLauncher />
    </VerticalLayout>
  );
});

Layout.propTypes = {
  children: PropTypes.node,
};
